import React from 'react';
import { motion } from 'framer-motion';
import { XCircle, CheckCircle2 } from 'lucide-react';
export function Transformation() {
  const before = ['No sabés qué cocinar', 'Sentís culpa al comer', 'Todo parece prohibido', 'Siempre terminás comiendo lo mismo', 'Las comidas son aburridas'];
  const after = ['Más variedad cada semana', 'Comidas que realmente dan ganas de comer', 'Reemplazos inteligentes', 'Más tranquilidad al sentarte a la mesa', 'Una alimentación mucho más disfrutable'];
  return <section className="py-20 md:py-32 px-6 bg-gray-50" data-id="element-213">
      <div className="max-w-5xl mx-auto" data-id="element-214">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-215">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-gray-900" data-id="element-216">
            Imaginá volver a disfrutar la comida
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8 md:gap-12" data-id="element-217">
          {/* Before */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white p-8 md:p-10 rounded-3xl shadow-sm border border-red-100 relative overflow-hidden" data-id="element-218">
            <div className="absolute top-0 left-0 w-full h-2 bg-red-400" data-id="element-219"></div>
            <h3 className="text-2xl font-bold text-gray-400 mb-8 uppercase tracking-wider text-center" data-id="element-220">
              Antes
            </h3>
            <ul className="space-y-6" data-id="element-221">
              {before.map((item, i) => <li key={i} className="flex items-start space-x-4" data-id="element-222">
                  <XCircle className="w-6 h-6 text-red-400 flex-shrink-0 mt-0.5" data-id="element-223" />
                  <span className="text-lg text-gray-600" data-id="element-224">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* After */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white p-8 md:p-10 rounded-3xl shadow-xl border border-green-100 relative overflow-hidden transform md:-translate-y-4" data-id="element-225">
            <div className="absolute top-0 left-0 w-full h-2 bg-primary" data-id="element-226"></div>
            <h3 className="text-2xl font-bold text-primary mb-8 uppercase tracking-wider text-center" data-id="element-227">
              Después
            </h3>
            <ul className="space-y-6" data-id="element-228">
              {after.map((item, i) => <li key={i} className="flex items-start space-x-4" data-id="element-229">
                  <CheckCircle2 className="w-6 h-6 text-primary flex-shrink-0 mt-0.5" data-id="element-230" />
                  <span className="text-lg text-gray-900 font-medium" data-id="element-231">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}